// @flow
import * as React from 'react';
import styles from './ContainerWithAside.module.scss';

type Props = {
  content: React.Node,
  asideContent: React.Node
};

const ContainerWithAside = ({ content, asideContent }: Props) => (
  <section className={styles.mainContainer}>
    <section className={styles.mainSection}>{content}</section>
    <aside className={styles.aside}>{asideContent}</aside>
  </section>
);

export default ContainerWithAside;
